export const getIsDarkTheme = state => state.theme.theme;
